import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7cc7058f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1,
  class: "product-push-status"
};
const _hoisted_3 = ["id"];
const _hoisted_4 = ["id"];
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "add-sku-btn"
};
const _hoisted_7 = {
  key: 2,
  class: "product-asin-sku-only product-sku-asin-text"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  class: "status-item"
};
const _hoisted_12 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_td = _resolveComponent("app-td");
  return _openBlock(), _createBlock(_component_app_td, {
    align: "center",
    class: "border-table-row stick-to-right",
    stickyColumn: "",
    style: _normalizeStyle({
      backgroundColor: `${$props.item.statusPush.color} !important`,
      padding: '12px 8px !important',
      right: $props.pushModal ? '0px' : '36px'
    })
  }, {
    default: _withCtx(() => [$props.push_loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_spinner, {
      small: ""
    })])) : _createCommentVNode("", true), !$props.push_loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
      class: "product-asin-sku-only status-icon",
      id: `${$props.item.content_id}-push-status`,
      onMouseover: _cache[0] || (_cache[0] = (...args) => $options.onMouseOver && $options.onMouseOver(...args)),
      onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.onMouseLeave && $options.onMouseLeave(...args))
    }, [$props.item.sku ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: $props.item.statusPush.icon
    }, null, 8, ["icon"])) : _createCommentVNode("", true), !$props.item.sku ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 1,
      icon: "no-sku"
    })) : _createCommentVNode("", true)], 40, _hoisted_3), _ctx.isPossibleToPush($props.item) && !$props.pushModal ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      id: `${$props.item.content_id}-push-btn`
    }, [_createElementVNode("div", {
      class: "push-btn",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('onConfirmPushSingleContent', $props.item))
    }, [_createVNode(_component_app_icon, {
      icon: "push-button"
    })]), _createVNode(_component_app_popover, {
      target: `${$props.item.content_id}-push-btn`,
      "auto-width": "",
      placement: "top",
      "custom-class": "push-to-amazon-btn"
    }, {
      default: _withCtx(() => [_createTextVNode(" Push updates to Amazon ")]),
      _: 1
    }, 8, ["target"])], 8, _hoisted_4)) : _createCommentVNode("", true), !$props.item.sku ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_app_icon, {
      icon: "tool"
    })])])) : _createCommentVNode("", true), !_ctx.isPossibleToPush($props.item) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [$props.item.last_push_date && $props.item.statusPush.status != 'unknown' ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($props.item.last_push_date), 1)) : _createCommentVNode("", true), $props.item.statusPush.status == 'accepted' && !$props.item.last_push_date ? (_openBlock(), _createElementBlock("span", _hoisted_9, "-")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $props.item.sku && !$props.push_loading ? (_openBlock(), _createBlock(_component_app_popover, {
      key: 2,
      target: `${$props.item.content_id}-push-status`,
      "auto-width": "",
      placement: "top",
      "custom-class": `${$options.getPushStatusClass($props.item)} ${!$props.showPopover ? 'hide-popover' : ''}`
    }, {
      title: _withCtx(() => [_createElementVNode("div", {
        style: _normalizeStyle({
          background: $props.item.statusPush.background_title
        })
      }, [_createElementVNode("div", {
        innerHTML: $props.item.statusPush.title
      }, null, 8, _hoisted_10)], 4)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        innerHTML: $props.item.statusPush.text
      }, null, 8, _hoisted_12)])]),
      _: 1
    }, 8, ["target", "custom-class"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["style"]);
}